import { render, staticRenderFns } from "./AtomButtonPrimary.vue?vue&type=template&id=831879d6"
import script from "./AtomButtonPrimary.vue?vue&type=script&lang=js"
export * from "./AtomButtonPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports